import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";

const safetyTopics = [
  { icon: "ri-car-line", label: "Vehicle Compatibility", text: "The vehicle is assessed for retrofit suitability before work begins." },
  { icon: "ri-plug-2-line", label: "Electrical Safety", text: "Electrical protection and isolation are treated as design requirements." },
  { icon: "ri-battery-saver-line", label: "Battery Safety", text: "Battery safety considerations shape selection and integration." },
  { icon: "ri-tools-line", label: "Mechanical Integration", text: "Mounting and mechanical fit are engineered around the vehicle." },
  { icon: "ri-git-branch-line", label: "Wiring & Protection", text: "Wiring, routing and protection form part of the retrofit architecture." },
  { icon: "ri-temp-hot-line", label: "Thermal Considerations", text: "Thermal behaviour of key components is considered during design." },
  { icon: "ri-test-tube-line", label: "Testing", text: "Testing and system checks follow before deployment." },
  { icon: "ri-verified-badge-line", label: "Quality Control", text: "Quality checks are applied through the retrofit process." },
  { icon: "ri-customer-service-2-line", label: "Serviceability", text: "Service access is considered so the vehicle can be maintained." },
];

export default function SafetySection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="Safety & Engineering"
            title="Engineering Discipline Applied to Every Retrofit"
            description="Retrofit is an engineering activity, not a parts swap. Safety, integration and serviceability are treated as requirements from assessment through deployment."
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {safetyTopics.map((topic, index) => (
            <Reveal key={topic.label} delay={index * 0.04}>
              <div className="flex h-full items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${topic.icon} text-lg`} />
                </span>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950">{topic.label}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{topic.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-10 rounded-lg border border-background-300 bg-background-50 p-5 text-xs leading-relaxed text-foreground-600">
            <i className="ri-information-line mr-2 text-foreground-500" />
            Certification and regulatory approval are not claimed for any retrofit unless verified for
            that specific vehicle and configuration. Applicable approvals depend on vehicle category,
            retrofit design and applicable regulations.
          </p>
        </Reveal>
      </div>
    </section>
  );
}